// api/processosService.js

import { api } from "./api";

export const processosService = {

  listar: async (clienteId = null) => {

    const response = await api.get("/processos", {
      params: clienteId ? { clienteId } : {}
    });

    return response.data;

  },

  criar: async (processo) => {
    const response = await api.post("/processos", processo);
    return response.data;
  },

  atualizar: async (id, alteracoes) => {
  const response = await api.patch(
    `/processos/${id}`,
    alteracoes
  );

  return response.data;
},

  excluir: async (id) => {
    await api.delete(`/processos/${id}`);
  }

};